import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';


@Component({
  selector: 'app-partners',
  standalone: true,
  imports: [],
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements AfterViewInit, OnDestroy {
  @ViewChild('partnersSection') partnersSection!: ElementRef;

  isVisible = false;

  originalSlides = [
    { src: '/assets/partners/inviu.png', alt: 'Inviu' },
    { src: '/assets/partners/Balanz.jpg', alt: 'Balanz' },
    { src: '/assets/partners/factorpyme.png', alt: 'FactorPyme', isFeatured: true },
    { src: '/assets/partners/cohen.png', alt: 'Cohen', isFeatured: true },
    { src: '/assets/partners/Payoneer.jpg', alt: 'Payoneer' },
  ];

  // Duplicamos el arreglo para lograr el bucle infinito continuo
  slides = [...this.originalSlides, ...this.originalSlides];

  private observer: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            if (this.observer) this.observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );

    if (this.partnersSection?.nativeElement) {
      this.observer.observe(this.partnersSection.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) this.observer.disconnect();
  }
}